import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input, Button, Table, Modal,
	message, Alert, Tag, Tooltip, Typography, Divider, Pagination,
} from 'antd';
import {
	PlusOutlined, FormOutlined, DeleteOutlined,
	ExclamationCircleOutlined, RedoOutlined,
	BankOutlined, SearchOutlined, ClockCircleOutlined,
	EnvironmentOutlined, PhoneOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data UPT',
	apiUrl: { data: 'pegawai/api/upt/' },
	pageUrl: { form: '/admin/upt/form/' },
	breadCrumb: ['Pegawai', 'UPT'],
};

const config = new Config();

class DataUpt extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		};
		this._searchTimer = null;
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		window.addEventListener('resize', this._handleResize);
		this.getData();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		const newPagination = {
			...this.state.pagination,
			pageSize: pagination.pageSize,
			current: pagination.current,
		};
		this.setState({ pagination: newPagination });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Hapus UPT?',
			icon: <ExclamationCircleOutlined />,
			content: 'Data UPT yang dihapus tidak dapat dikembalikan.',
			okText: 'Hapus',
			okType: 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Data berhasil dihapus', duration: 2, key: 'toast' });
					this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
					this.getData(this.state.pagination.pageSize, 0);
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal menghapus data', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan koneksi', duration: 2, key: 'toast' }));
	}

	_renderAksi(row) {
		return (
			<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
				<Tooltip title="Edit UPT">
					<Link to={configClass.pageUrl.form + row.id}>
						<Button
							size="small"
							shape="circle"
							style={{ borderColor: '#1890ff', color: '#1890ff' }}
							icon={<FormOutlined />}
						/>
					</Link>
				</Tooltip>
				<Tooltip title="Hapus UPT">
					<Button
						size="small"
						shape="circle"
						danger
						icon={<DeleteOutlined />}
						onClick={() => this.showDeleteConfirm(row.id)}
					/>
				</Tooltip>
			</div>
		);
	}

	_buildColumns() {
		return [
			{
				title: 'Nama UPT',
				dataIndex: 'nama',
				key: 'nama',
				width: 200,
				render: (value, row) => (
					<div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value}</div>
						<div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
							{row.kode && <Tag color="blue" style={{ fontSize: 10, borderRadius: 4 }}>{row.kode}</Tag>}
							{row.is_pusat && <Tag color="purple" style={{ fontSize: 10, borderRadius: 4 }}>Pusat</Tag>}
							{row.is_bypass && <Tag color="orange" style={{ fontSize: 10, borderRadius: 4 }}>Bypass</Tag>}
						</div>
					</div>
				),
			},
			{
				title: 'Kabupaten',
				dataIndex: 'kabupaten_nama',
				key: 'kabupaten_nama',
				width: 160,
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
						<EnvironmentOutlined style={{ color: '#1890ff', fontSize: 12 }} />
						<span style={{ fontSize: 13 }}>{value || '—'}</span>
					</div>
				),
			},
			{
				title: 'Kode Jasaraharja',
				dataIndex: 'kode_jasaraharja',
				key: 'kode_jasaraharja',
				width: 130,
				render: (value) => (
					<Tag style={{ fontFamily: 'monospace', borderRadius: 4 }}>{value || '—'}</Tag>
				),
			},
			{
				title: 'Jam Operasional',
				key: 'jam',
				width: 160,
				render: (_, row) => {
					const hari = Array.isArray(row.hari_nama) ? row.hari_nama : [];
					return (
						<div>
							{row.mulai_dari && (
								<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 4 }}>
									<ClockCircleOutlined style={{ color: '#52c41a', fontSize: 11 }} />
									<span style={{ fontSize: 12, fontWeight: 600, color: '#222' }}>
										{row.mulai_dari} — {row.sampai_dengan}
									</span>
								</div>
							)}
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
								{hari.map((h, i) => (
									<Tag key={i} color="default" style={{ fontSize: 10, margin: 0, borderRadius: 4, padding: '0 4px' }}>{h}</Tag>
								))}
							</div>
						</div>
					);
				},
			},
			{
				title: 'Kontak',
				key: 'kontak',
				width: 180,
				render: (_, row) => (
					<div>
						{row.telpon && (
							<div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 3 }}>
								<PhoneOutlined style={{ color: '#888', fontSize: 11 }} />
								<span style={{ fontSize: 12 }}>{row.telpon}</span>
							</div>
						)}
						{row.alamat && (
							<div style={{ fontSize: 11, color: '#888', lineHeight: 1.4 }}>
								{row.alamat}
							</div>
						)}
					</div>
				),
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 90,
				fixed: 'right',
				render: (_, row) => this._renderAksi(row),
			},
		];
	}

	renderMobileCard(row) {
		const hari = Array.isArray(row.hari_nama) ? row.hari_nama : [];
		return (
			<div key={row.id} style={{
				background: '#fff',
				borderRadius: 12,
				boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
				padding: 16,
				marginBottom: 12,
				border: '1px solid #f0f0f0',
			}}>
				{/* Header card */}
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', marginBottom: 4 }}>
							{row.nama}
						</div>
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
							{row.kode && <Tag color="blue" style={{ fontSize: 10, borderRadius: 4 }}>{row.kode}</Tag>}
							{row.is_pusat && <Tag color="purple" style={{ fontSize: 10, borderRadius: 4 }}>Pusat</Tag>}
							{row.is_bypass && <Tag color="orange" style={{ fontSize: 10, borderRadius: 4 }}>Bypass</Tag>}
						</div>
					</div>
					<div style={{ display: 'flex', gap: 6, flexShrink: 0, marginLeft: 8 }}>
						<Tooltip title="Edit">
							<Link to={configClass.pageUrl.form + row.id}>
								<Button size="small" shape="circle" style={{ borderColor: '#1890ff', color: '#1890ff' }} icon={<FormOutlined />} />
							</Link>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger icon={<DeleteOutlined />} onClick={() => this.showDeleteConfirm(row.id)} />
						</Tooltip>
					</div>
				</div>

				<Divider style={{ margin: '8px 0' }} />

				{/* Detail rows */}
				{[
					{ icon: <EnvironmentOutlined />, label: 'Kabupaten', value: row.kabupaten_nama },
					{ icon: <PhoneOutlined />, label: 'Telpon', value: row.telpon },
					{
						icon: <ClockCircleOutlined />, label: 'Jam', value: row.mulai_dari
							? `${row.mulai_dari} — ${row.sampai_dengan}`
							: null,
					},
				].filter(r => r.value).map(r => (
					<div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
						<span style={{ color: '#1890ff', fontSize: 12, width: 14, flexShrink: 0 }}>{r.icon}</span>
						<Text style={{ fontSize: 11, color: '#888', width: 60, flexShrink: 0 }}>{r.label}</Text>
						<Text style={{ fontSize: 12, color: '#333' }}>{r.value}</Text>
					</div>
				))}

				{hari.length > 0 && (
					<div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 4 }}>
						<span style={{ color: '#1890ff', fontSize: 12, width: 14, flexShrink: 0, marginTop: 2 }}>📅</span>
						<Text style={{ fontSize: 11, color: '#888', width: 60, flexShrink: 0 }}>Hari</Text>
						<div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
							{hari.map((h, i) => <Tag key={i} color="default" style={{ fontSize: 10, margin: 0, borderRadius: 4 }}>{h}</Tag>)}
						</div>
					</div>
				)}

				{row.alamat && (
					<div style={{ marginTop: 8, padding: '6px 10px', background: '#f9fafb', borderRadius: 6, fontSize: 11, color: '#666' }}>
						{row.alamat}
					</div>
				)}
			</div>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.data-upt-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 12px;
							color: #333;
							border-bottom: 2px solid #e8e8e8;
							text-transform: none !important;
						}
						.data-upt-wrap .ant-table-tbody > tr > td {
							padding: 10px 14px;
							vertical-align: middle;
							text-transform: none !important;
						}
						.data-upt-wrap .ant-table-tbody > tr:hover > td {
							background: #e6f7ff !important;
						}
						.data-upt-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-upt-wrap .ant-table-cell,
						.data-upt-wrap .ant-table-cell * {
							text-transform: none !important;
						}
						.data-upt-wrap .ant-input,
						.data-upt-wrap .ant-input-affix-wrapper input {
							text-transform: none !important;
						}
					`}</style>
				</Helmet>


				<Card
					className="data-upt-wrap"
					bodyStyle={{ padding: 0 }}
					style={{ borderRadius: 14, boxShadow: '0 4px 24px rgba(0,0,0,0.09)', overflow: 'hidden', border: 'none' }}
				>
					{/* ── Header gradient ── */}
					<div style={{
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						padding: '18px 24px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						flexWrap: 'wrap',
						gap: 10,
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
							<div style={{
								background: 'rgba(255,255,255,0.15)',
								borderRadius: 10,
								width: 40, height: 40,
								display: 'flex', alignItems: 'center', justifyContent: 'center',
							}}>
								<BankOutlined style={{ color: '#fff', fontSize: 18 }} />
							</div>
							<div>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>{configClass.title}</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12 }}>
									{pagination.total > 0 ? `${pagination.total} UPT terdaftar` : 'Memuat data...'}
								</div>
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => {
										this.setState(prev => ({
											searchText: '',
											pagination: { ...prev.pagination, current: 1 },
										}), () => this.getData(this.state.pagination.pageSize, 0, ''));
									}}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									Refresh
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button
									type="primary"
									icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#52c41a', borderColor: '#52c41a', fontWeight: 600 }}
								>
									Tambah UPT
								</Button>
							</Link>
						</div>
					</div>

					{/* ── Error alert ── */}
					<ErrorAlertModal
						visible={errMsg !== ''}
						title={errTitle}
						error={errMsg}
						onClose={() => this.setState({ errMsg: '', errTitle: '' })}
					/>

					{/* ── Search bar ── */}
					<div style={{ padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Input
							placeholder="Cari nama, kabupaten, atau kode UPT..."
							allowClear
							size="large"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 460, textTransform: 'none' }}
							value={this.state.searchText}
							onChange={this.handleSearchChange}
						/>
					</div>

					{/* ── Content ── */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total}`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataUpt);
